import api from "@/lib/api";

let lastSent = 0;
const seen = new Set();

export function reportError({ message, stack, path }) {
  try {
    const now = Date.now();
    if (now - lastSent < 1500) return; // throttle bursts
    const key = String(message || "").slice(0, 140);
    if (seen.has(key)) return; // dedupe repeats within a session
    seen.add(key);
    lastSent = now;
    api.post("/monitoring/client-error", {
      message: String(message || "").slice(0, 2000),
      stack: String(stack || "").slice(0, 6000),
      path: path || (typeof window !== "undefined" ? window.location.pathname : ""),
    }).catch(() => {});
  } catch { /* never let reporting break the app */ }
}

export function initErrorReporting() {
  if (typeof window === "undefined" || window.__pulaErrInit) return;
  window.__pulaErrInit = true;
  // Optional: browser-side Sentry (auto-captures uncaught errors with full stacks).
  // Loaded dynamically so it only ships when a DSN is configured.
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (dsn) {
    import("@sentry/react")
      .then((Sentry) => {
        Sentry.init({
          dsn,
          environment: process.env.REACT_APP_ENV || "production",
          tracesSampleRate: 0.1,
          integrations: [Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true })],
          replaysSessionSampleRate: 0.1,   // 10% of normal sessions
          replaysOnErrorSampleRate: 1.0,   // always capture a replay when an error happens
        });
      })
      .catch(() => {});
  }
  window.addEventListener("error", (e) => {
    reportError({ message: e.message, stack: e.error?.stack, path: window.location.pathname });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    reportError({ message: "Unhandled rejection: " + (r?.message || r), stack: r?.stack, path: window.location.pathname });
  });
}
